import React from 'react'
import '../css/done.scss'

function Done() {
    return (
        <div className="done">
          <img src="https://e.lvme.me/3llagu9.jpg" alt=""/>
        </div>
    )
}

export default Done
